import styled from 'styled-components'

const StyledWrapper = styled.div`
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;

  .lds-dual-ring {
    display: inline-block;
    width: 24px;
    height: 24px;
  }

  .lds-dual-ring:after {
    content: ' ';
    display: block;
    width: 24px;
    height: 24px;
    margin: 0;
    border-radius: 50%;
    border: 2px solid #cf0101;
    border-color: #cf0101 transparent #cf0101 transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const Loading = () => {
  return (
    <StyledWrapper className='loading-wrapper'>
      <div className='lds-dual-ring'></div>
    </StyledWrapper>
  )
}

export default Loading
